import { RelyingPartyDetailsState } from "@idw-types/state/relying-party-details-state";
import { getRelyingPartyDetailsState } from "@redux/selectors/root-selectors";
import { createSelector } from "reselect";

export const getRelyingPartyDetailsDataState = createSelector(getRelyingPartyDetailsState, (state: RelyingPartyDetailsState) => {
    return {
        isLoadingRelyingParty: state.relyingParty.isLoading,
        relyingParty: state.relyingParty.relyingParty
    }
});